<template>
  <LoginLayout>
    <Login/>
  </LoginLayout>
</template>

<script>
import LoginLayout from '../layouts/LoginLayout'
import Login from '../components/Reset'

export default {
    components: {
    LoginLayout,
    Login
  }
};
</script>
